import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/customer/recover", { email }); } catch { /* silent */ }
    setSent(true);
    toast.success("If an account exists, a reset link is on its way.");
  };
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-taven-gray/30" data-testid="forgot-page">
      <div className="w-full max-w-md bg-white border border-black/10 p-8 md:p-10">
        <h1 className="text-xl font-black font-display text-center">Reset your password</h1>
        {sent ? (
          <p className="text-sm text-muted-foreground text-center mt-4" data-testid="forgot-sent">If an account exists for <strong>{email}</strong>, we've sent a secure reset link. Please check your inbox.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your account email" data-testid="forgot-email" className="w-full border border-black/15 focus:border-taven-gold px-4 py-3.5 text-sm outline-none" />
            <button data-testid="forgot-submit" className="w-full bg-taven-black text-white font-bold uppercase tracking-wider py-4 hover:bg-taven-orange transition-colors">Send Reset Link</button>
          </form>
        )}
        <p className="mt-6 text-center text-sm"><Link to="/login" className="text-taven-gold hover:underline">Back to sign in</Link></p>
      </div>
    </div>
  );
}
